<template>
  <div
    class="page flex-col"
    style="
      background-image: url(/static/img/background-login.jpg);
      background-size: cover;
      background-repeat: no-repeat;
    "
  >
    <loginBox></loginBox>
    <!-- <div
      class="wrap2 flex-col align-center"
      style="font-size: 20px"
      v-if="type != 2 && type != 1"
    >
      <div
        class="flex-row justify-between align-center"
        style="
          padding-top: 30px;
          padding-bottom: 20px;
          padding-left: 30px;
          padding-right: 30px;
          width: 100%;
        "
      >
        <i
          style="cursor: pointer"
          @click="type = 2"
          class="el-icon-arrow-left"
        ></i>
        <i style="cursor: pointer" @click="type = 2" class="el-icon-close"></i>
      </div>
      <span style="margin-bottom: 15px; font-size: 18px">微信登録</span>
      <vue-qr
        text="的期望的期望的期望带我去打网球的委屈委屈带我去我去单位请问带我去权威的去的期望的期望带我去打网球的委屈委屈带我去我去单位请问带我去权威的去的期望的期望带我去打网球的委屈委屈带我去我去单位请问带我去权威的去的期望的期望带我去打网球的委屈委去我去单位请问带我去权威的去"
        logoMargin="5"
        logoScale="0.12"
        :logoSrc="logoSrc"
        :size="200"
        :margin="0"
      ></vue-qr>
      <span style="margin-top: 20px; margin-bottom: 20px; font-size: 18px"
        >使用微信掃碼登録</span
      >
      <div style="color: #bcbcbc; font-size: 14px">
        沒有賬號？<span style="color: #aa1d1f">立即注册</span>
      </div>
    </div> -->
    <!-- 绑定手机号 -->
  </div>
</template>
<script>
export default {
  name: "login",
}

</script>
<style lang="less" scoped>
.page {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("/static/login/loginbg.png");
  background-size: cover;
  // background-repeat: no-repeat;
  background-position: center; /* 确保图片居中 */
  background-color: rgba(245, 245, 245, 1);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Courier New", Courier, monospace;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue